<template>
  <v-container fluid grid-list-sm>
    <master-management-panel @handleAction="onAction"/>
  </v-container>
</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';
import { Components } from '@core/helpers/decorators';
import MasterManagementPanel from './components/MasterManagementPanel.vue';

@Component
@Components({ MasterManagementPanel })
export default class MasterManagement extends Vue {
  onAction(routeName) {
    this.$router.push({ name: routeName });
  }
}

</script>
